import React from "react";
import { ReactComponent as WalkingInActive } from "assets/images/icon_walking_inactive.svg";
import { ReactComponent as WalkingActive } from "assets/images/icon_walking_active.svg";
import { ReactComponent as Elevator } from "assets/images/icon_elevator_inactive.svg";
import { ReactComponent as Escalator } from "assets/images/icon_escalator_inactive.svg";
import { ReactComponent as PinActive } from "assets/images/icon_pin_active.svg";
import { ReactComponent as PinInActive } from "assets/images/icon_pin_inactive.svg";
import { ReactComponent as EndPoint } from "assets/images/icon_end_point.svg";
import { ReactComponent as StartPoint } from "assets/images/icon_start_point.svg";
import { ReactComponent as Running } from "assets/images/icon_running.svg";
import { useSelector } from "react-redux";
import { walkingSpeed } from "config/constants";
import languages from "languages/languages";
import styles from "./MapTravelBar.module.css";

const MapTravelBar = ({
  vertical,
  layout,
  pathToElevator,
  pathToDestination,
  destinationName,
  isOnDestination,
  commuteByEscalator,
  isTargetOnDifferntFloor,
  currentFloorLevel,
  destinationFloorLevel,
  costToDestinationOfMainFloor,
  costToDestinationOfDestinationFloor,
}) => {
  const langState = useSelector((state) => state.language.lang);
  const totalCost = isTargetOnDifferntFloor
    ? (
        costToDestinationOfMainFloor + costToDestinationOfDestinationFloor
      ).toFixed(2)
    : costToDestinationOfMainFloor.toFixed(2);
  const travelTime =
    totalCost / walkingSpeed > 1 ? (totalCost / walkingSpeed).toFixed(0) : 1;
  
  const differentFloor = Math.abs(destinationFloorLevel - currentFloorLevel)

  return (
    <div
      className={`${styles[layout + "_mtb"]}  ${
        vertical ? styles.vertical : ""
      }`}
    >
      <div className={styles.direction}>
        <p className={styles.start}>
          <StartPoint />
          <span>{languages[langState]["Vị trí của bạn"]}</span>
        </p>
        <p className={styles.end}>
          <EndPoint />
          <span>{destinationName || ""}</span>
        </p>
        <p>
          <Running />
          <span>
            {totalCost} m - {travelTime} {languages[langState]["phút"]}
          </span>
        </p>
      </div>

      {isTargetOnDifferntFloor && (
        <div className={`${styles.travel_bar_wrapper}`}>
          <div className={`${styles.travel_bar}`}>
            <button type="button" onClick={pathToElevator}>
            <WalkingActive  className={`${styles.walking_active}`}/>
            </button>
            <button
              type="button"
              onClick={pathToElevator}
              className={`${styles.no_focus_outline}`}
            >
              {commuteByEscalator ? <Escalator className={`${styles.escalator_active}`} /> : <Elevator />}
            </button>
            {
              differentFloor > 1 && (<button
                type="button"
                onClick={pathToDestination}
                className={`${styles.no_focus_outline}`}
              >
                {commuteByEscalator ? <Escalator className={`${styles.escalator_active}`} /> : <Elevator />}
              </button>)
            }
            
            <button type="button" onClick={pathToDestination}>
              <PinActive className={`${styles.pin_active}`} /> 
            </button>
          </div>

          <div className={`${styles.floor}  ${styles.start_floor}`}>
            <p>{currentFloorLevel}F</p>
            <p>{costToDestinationOfMainFloor.toFixed(2)} m</p>
          </div>

          <div className={`${styles.floor}  ${styles.end_floor}`}>
            <p>{destinationFloorLevel}F</p>
            <p>{costToDestinationOfDestinationFloor.toFixed(2)} m</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapTravelBar;
